import { extensions } from '../../extensions/Extensions.mjs';
import { GlParticleContainerPipe } from './shared/GlParticleContainerPipe.mjs';
import { GpuParticleContainerPipe } from './shared/GpuParticleContainerPipe.mjs';

"use strict";
extensions.add(GlParticleContainerPipe);
extensions.add(GpuParticleContainerPipe);
//# sourceMappingURL=init.mjs.map
